import React from "react";
import StyledMdText from "../../../../common/components/styledMdText/StyledMdText";
import MarketplaceStatus from "../../../../components/Marketplace/MarketplaceStatus";
import StyledH5Heading from "../../../../common/components/styledH5Heading/StyledH5Heading";
import StyledH2Heading from "../../../../common/components/styledH2Heading/StyledH2Heading";

const GoldenStorySection = () => {
  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex flex-col justify-center items-start gap-10 lg:flex-row lg:justify-between lg:items-center py-5 md:py-20">
        <div className="md:w-4/5 lg:w-2/3 xl:w-[41%] flex flex-col justify-start gap-6">
          <div className="space-y-1">
            <StyledH5Heading fontColor={"-mb-2"}>Top Secret</StyledH5Heading>
            <StyledH2Heading fontColor={"textGradient"}>
              Golden Story
            </StyledH2Heading>
            <div className="pr-4"> 
            <StyledMdText>
              In publishing and graphic design, Lorem ipsum is a placeholder
              text commonly used to demonstrate the visual form of a document or
              a typeface without relying on meaningful content. Lorem ipsum may
              be used as a placeholder before the final copy is available.In
              publishing and graphic design, Lorem ipsum is a placeholder text
              commonly used to demonstrate the visual form of a document or a
              typeface without relying on meaningful content. Lorem ipsum may be
              used as a placeholder before the final copy is available.
            </StyledMdText>
            </div>
          </div>
          <div>
            <MarketplaceStatus />
          </div>
        </div>
        <div className="w-full md:w-[100%] md:self-center lg:w-1/2 lg:self-end">
          <img src="/assets/golden-story.png" alt="golden story is missing" loading="lazy"/>
        </div>
      </div>
    </div>
  );
};

export default GoldenStorySection;

